import { AFFILIATE_DISCLOSURE_FULL } from "@/lib/affiliateUtils";

export default function AffiliateDisclosure({ variant = "inline" }) {
  if (variant === "bar") {
    return (
      <div className="bg-secondary/60 border-b border-border">
        <div className="max-w-7xl mx-auto px-4 py-2">
          <p className="text-xs font-mono text-muted-foreground text-center tracking-wide">
            <span className="text-accent-text font-semibold">[COMPLIANCE]</span>{" "}
            {AFFILIATE_DISCLOSURE_FULL}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-secondary/50 border border-border rounded-lg px-4 py-3 mb-6">
      <p className="text-sm font-mono text-muted-foreground">
        <span className="text-accent-text font-semibold">Disclosure:</span>{" "}
        {AFFILIATE_DISCLOSURE_FULL}
      </p>
    </div>
  );
}